import gql from 'graphql-tag'
import { IProjectionConnectionWithTotal } from '@api/types'
import client from '../../stores/apollo'

interface IPayload {
  data: {
    viewer: {
      company: {
        projection_imports: IProjectionConnectionWithTotal
        floor_projection_imports: IProjectionConnectionWithTotal
      }
    }
  }
}

export interface IProjectionVariables {
  first?: number
  after?: string | null
}

export default function list(
  variables: IProjectionVariables,
  tab: string
): Promise<IProjectionConnectionWithTotal> {
  return client.gql
    .query({
      query: tab === 'building' ? buildingProjectionsQuery : floorProjectionsQuery,
      variables: variables,
    })
    .then(
      ({
        data: {
          viewer: { company },
        },
      }: IPayload) => {
        return tab === 'building' ? company.projection_imports : company.floor_projection_imports
      }
    )
}

export const buildingProjectionsQuery = gql`
  query ProjectionImports($after: String, $first: Int) {
    viewer {
      company {
        projection_imports(first: $first, after: $after) {
          edges {
            node {
              id
              status
              totalCount
              createdAt
              createdCount
              updatedCount
              failedCount
              importedBy
              url
              skippedCount
              failed {
                errors {
                  building
                  department
                }
                object {
                  buildingCode
                  departmentName
                  date
                  rowNum
                  numberAmount
                }
              }
            }
          }
        }
      }
    }
  }
`

export const floorProjectionsQuery = gql`
  query ProjectionImports($after: String, $first: Int) {
    viewer {
      company {
        floor_projection_imports(first: $first, after: $after) {
          edges {
            node {
              id
              status
              totalCount
              createdAt
              createdCount
              updatedCount
              failedCount
              importedBy
              url
              skippedCount
              failed {
                errors {
                  building
                  floor
                  department
                }
                object {
                  buildingCode
                  floorCode
                  departmentName
                  date
                  rowNum
                  numberAmount
                }
              }
            }
          }
        }
      }
    }
  }
`
